module.exports = __webpack_public_path__ + "img/swisscom-pay.c313b4f2.svg";